import { useQuery } from "@tanstack/react-query";
import { fetchCmsContent, cmsEnabled } from "../services/cmsService";
import { CmsContent } from "../types/cms.types";

/**
* Provides the CMS managed texts (hero banners, footer links, aktuality).
* Returns undefined while loading, when the CMS is not configured,
* or when the fetch fails — consumers then keep their built-in fallbacks.
*/
export const useCmsContent = (): CmsContent | undefined => {
    const { data } = useQuery({
        queryKey: ["cmsContent"],
        queryFn: fetchCmsContent,
        enabled: cmsEnabled,
        staleTime: 5 * 60 * 1000,
        retry: 1,
    });
    return data ?? undefined;
};
